module.exports = __webpack_public_path__ + "static/img/8.80f4c00.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/sp/8.png
// module id = fqM4
// module chunks = 0